"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var entity_factory_1 = require("../factory/entity-factory");
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
var HttpService = /** @class */ (function () {
    function HttpService(_http) {
        this._http = _http;
        this.isLoadingSubject = new Subject_1.Subject();
        this.isLoading$ = this.isLoadingSubject.asObservable();
    }
    HttpService.prototype.post = function (URL, payload, ResponseType, ErrorType) {
        var typedResponse = this.getCorrectTypeInstanceFrom(ResponseType);
        var typedError = this.getCorrectTypeInstanceFrom(ErrorType);
        this.isLoadingSubject.next(true);
        var request = this._http.post(URL, payload);
        return this.applyMapCatchFinally(request, typedError, typedResponse);
    };
    HttpService.prototype.get = function (URL, ResponseType, ErrorType) {
        var typedResponse = this.getCorrectTypeInstanceFrom(ResponseType);
        var typedError = this.getCorrectTypeInstanceFrom(ErrorType);
        this.isLoadingSubject.next(true);
        var request = this._http.get(URL);
        return this.applyMapCatchFinally(request, typedError, typedResponse);
    };
    HttpService.prototype.put = function (URL, payload, ResponseType, ErrorType) {
        var typedResponse = this.getCorrectTypeInstanceFrom(ResponseType);
        var typedError = this.getCorrectTypeInstanceFrom(ErrorType);
        this.isLoadingSubject.next(true);
        var request = this._http.put(URL, payload);
        return this.applyMapCatchFinally(request, typedError, typedResponse);
    };
    HttpService.prototype.delete = function (URL, ErrorType, ResponseType) {
        var typedError = this.getCorrectTypeInstanceFrom(ErrorType);
        this.isLoadingSubject.next(true);
        var request = this._http.delete(URL);
        if (ResponseType) {
            var typedResponse = this.getCorrectTypeInstanceFrom(ResponseType);
            return this.applyMapCatchFinally(request, typedError, typedResponse);
        }
        return this.applyMapCatchFinally(request, typedError);
    };
    HttpService.prototype.applyMapCatchFinally = function (request, typedError, typedResponse) {
        request = this.applyMap(request, typedResponse);
        request = this.applyCatch(request, typedError);
        request = this.applyFinally(request);
        return request;
    };
    HttpService.prototype.applyMap = function (request, typedResponse) {
        if (typedResponse) {
            return request
                .map(function (res) {
                return Object.assign(typedResponse, res);
            });
        }
        return request;
    };
    HttpService.prototype.applyCatch = function (request, typedError) {
        var _this = this;
        return request
            .catch(function (error) {
            typedError.text = _this.getErrorMessage(error);
            return Observable_1.Observable.throw(typedError);
        });
    };
    HttpService.prototype.applyFinally = function (request) {
        var _this = this;
        return request
            .finally(function () { return _this.isLoadingSubject.next(false); });
    };
    HttpService.prototype.getCorrectTypeInstanceFrom = function (Type) {
        return entity_factory_1.EntityFactory.getEntityInstance(Type);
    };
    HttpService.prototype.getErrorMessage = function (error) {
        if (error.error && error.error.message) {
            return error.error.message;
        }
        else {
            var insideError = JSON.parse(error.error);
            if (insideError.message) {
                return insideError.message;
            }
        }
        if (error.message) {
            return error.message;
        }
        return 'Algo de errado ocorreu';
    };
    HttpService.ctorParameters = function () { return [{ type: http_1.HttpClient }]; };
    return HttpService;
}());
exports.HttpService = HttpService;
//# sourceMappingURL=http.service.js.map


// WEBPACK FOOTER //
// http.service.js